module.exports = __webpack_public_path__ + "static/media/unit4-logo.0b4c28ad.svg";